exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.main-block-btn[data-v-1344960f] .v-icon {\n\t\tcolor: var(--grey-pipe);\n}\n.menu-btn.active[data-v-1344960f] .v-icon {\n\t\tcolor: var(--aqua-active);\n}\n.hide-menu-btn__button[data-v-1344960f] .v-ripple__container {\n\t\tdisplay: none\n}\n", ""]);

